import { d as g } from "./chunk-debounce-Bk6yKvzA.js";
const m = (l) => {
  switch (l) {
    case "store":
      return `
      <span class='rounded-xs uppercase text-xs inline-flex items-center'>
        <span class='sr-only'>${l}: </span>
        <svg-icon src='icon-pin' class='fill-current size-4'></svg-icon>
      </span>
      `;
    default:
      return "";
  }
}, S = (l) => `<li class="shrink-0">
    <a class="btn btn--pill" href="${l.url}">
      ${m(l.type)}
      <span class='line-clamp-1'>
        ${l.title.split(" | ")[0]}
      </span>
    </a>
  </li>`, f = class f extends HTMLElement {
  constructor() {
    var t, e;
    super(), this.renderIcon = m, this.renderSuggestion = S, this.GROUPS = ["pages", "stores"], this.form = this.querySelector("form"), this.input = (t = this.form) == null ? void 0 : t.querySelector(
      'input[type="search"]'
    ), this.clear = (e = this.form) == null ? void 0 : e.querySelector(
      'button[type="reset"]'
    ), this.suggestions = this.querySelector("#suggestions"), this.results = null, this.handleSubmit = this.handleSubmit.bind(this), this.handleSubmitDebounced = g(this.handleSubmit, 500);
  }
  connectedCallback() {
    !this.form || !this.input || (this.handleSubmit(!0), this.form.addEventListener("submit", (t) => {
      t.preventDefault(), this.handleSubmitDebounced();
    }), this.form.addEventListener("input", (t) => {
      t.preventDefault(), this.handleSubmitDebounced();
    }), this.form.addEventListener("reset", (t) => {
      t.preventDefault(), this.handleReset();
    }), this.clear && (this.clear.addEventListener("click", (t) => {
      t.preventDefault(), this.handleReset();
    }), this.addEventListener("facet-filters::update", (t) => {
      const s = t.detail.productsCount;
      this.dataset.productCount = s;
    })));
  }
  attributeChangedCallback(t) {
    (t === "data-product-count" || t === "data-content-count") && this.updateState();
  }
  handleSubmit(t = !1) {
    if (!this.form || !this.input)
      return;
    if (!this.input.value || this.input.value.length < 3) {
      this.handleClear();
      return;
    }
    const e = encodeURIComponent(this.input.value);
    this.search(e), !t && this.searchProducts(e);
  }
  handleClear() {
    var s;
    const t = new URL(window.location.href);
    t.search = "", window.history.pushState({}, "", t.toString()), this.GROUPS.forEach((i) => {
      var a, c;
      const r = this.querySelector(
        `#results--${i} [data-results]`
      );
      if (!r)
        return;
      const n = this.querySelector(`[data-count="${i}"]`);
      n && (n.innerHTML = "", (a = this.querySelector(`#tab-${i}`)) == null || a.setAttribute("data-empty", ""), (c = this.querySelector(`#tabpanel-${i}`)) == null || c.setAttribute("data-empty", "")), i === "stores" ? r.querySelectorAll("[data-store-handle]").forEach((o) => {
        o.setAttribute("data-filtered", "true");
      }) : r.innerHTML = "";
    }), this.dataset.contentCount = "0", (s = this.suggestions) != null && s.innerHTML && (this.suggestions.innerHTML = ""), this.searchProducts("");
    const e = document.getElementById("collection");
    e && e != null && e.innerHTML && (e.innerHTML = "");
  }
  handleReset() {
    this.input && (this.input.value = ""), this.handleClear(), setTimeout(() => {
      var t;
      (t = this.input) == null || t.focus();
    }, 100);
  }
  search(t) {
    const e = new URL(window.location.href), s = e.searchParams.get("page");
    e.search = "", e.searchParams.set("q", t), s && e.searchParams.set("page", s), window.history.pushState({ q: t, page: s }, "", e.toString()), fetch(`https://search.watchesofswitzerland.com/?q=${t}`, {
      method: "GET"
    }).then((i) => i.json()).then((i) => {
      var r;
      i && (this.results = (r = i == null ? void 0 : i.result) == null ? void 0 : r.results, this.renderResults(), this.renderSuggestions());
    }).catch((i) => {
      console.error("Error fetching search results:", i);
    });
  }
  renderImage(t) {
    return `<div class="aspect-video bg-brand-darkest group-hover/result:opacity-80 transition-opacity mb-2 rounded-sm flex items-center justify-center">
      <img class="object-contain h-12 max-w-3/4 ${!t.logo && t.type !== "rolex" && "invert max-h-8"}" src="${t.logo ? t.logo : t.type == "rolex" ? "/cdn/shop/files/Rolex_Logo_White.svg" : "/cdn/shop/files/WOS-Mark-Black.svg"}" alt="${t.title}" />
    </div>`;
  }
  renderItem(t) {
    return `<li class="flex flex-col gap-2 justify-end relative group/result">
      ${this.renderImage(t)}
      <a class="after:absolute after:inset-0 hover:text-brand-darker h6" href="${t.url}">
        <span>${t.title}</span>
      </a>
      ${t.description ? `<div class='text-brand-dark line-clamp-2'>
          ${t.description}
        </div>` : ""}
    </li>`;
  }
  renderResults() {
    this.results && (this.dataset.contentCount = this.results.count.toString(), this.GROUPS.forEach((t) => {
      var r, n, a, c, u;
      const e = this.querySelector(
        `#results--${t} [data-results]`
      );
      if (!e)
        return;
      t !== "stores" && (e.innerHTML = "");
      const s = (r = this.results) == null ? void 0 : r.groups.find(
        (o) => o.values[0] === t
      ), i = this.querySelector(`[data-count="${t}"]`);
      if (i && (s != null && s.result ? (i.innerHTML = "(" + (s == null ? void 0 : s.result.length.toString()) + ")", (n = this.querySelector(`#tab-${t}`)) == null || n.removeAttribute("data-empty"), (a = this.querySelector(`#tabpanel-${t}`)) == null || a.removeAttribute(
        "data-empty"
      )) : (i.innerHTML = "", (c = this.querySelector(`#tab-${t}`)) == null || c.setAttribute("data-empty", ""), (u = this.querySelector(`#tabpanel-${t}`)) == null || u.setAttribute(
        "data-empty",
        ""
      ))), !!s)
        if (t === "stores") {
          const o = s.result.map(
            (h) => h.document.url.split("/pages/showrooms/")[1]
          );
          e.querySelectorAll("[data-store-handle]").forEach((h) => {
            const b = h.getAttribute("data-store-handle");
            b && (o.includes(b) ? h.removeAttribute("data-filtered") : h.setAttribute("data-filtered", "true"));
          });
        } else {
          let o = "";
          s.result.forEach((p) => {
            o += this.renderItem(p.document);
          }), e.innerHTML = o;
        }
    }));
  }
  renderSuggestions() {
    if (!this.suggestions || !this.results)
      return;
    if (this.results.hits.length === 0) {
      this.suggestions.innerHTML = "";
      return;
    }
    const t = this.results.hits.slice(0, 3);
    let e = "";
    t.forEach((s) => {
      e += this.renderSuggestion(s.document);
    }), this.suggestions.innerHTML = `<ul class='relative mb-2 md:mb-4 px-safe-or-2 pb-2 pt-1 flex lg:flex-wrap overflow-auto items-center lg:justify-center gap-2 md:gap-4 w-full scrollbar-none overscroll-contain'>${e}</ul>`;
  }
  searchProducts(t) {
    this.dataset.loading = "true";
    const s = new URL(window.location.href).searchParams.get("page");
    if (!t.length) {
      const i = document.getElementById("collection");
      i && (i.innerHTML = "", i.dataset.product = "0"), this.dataset.productCount = "0", this.dataset.loading = "false";
      return;
    }
    fetch(
      `/search?q=${t}${s ? "&page=" + s : ""}&options[prefix]=last&section_id=${this.dataset.sectionId}`
    ).then((i) => i.text()).then((i) => {
      if (i) {
        const n = new DOMParser().parseFromString(i, "text/html").querySelector("#collection"), a = document.getElementById("collection");
        if (a && n) {
          a.innerHTML = n.innerHTML || "";
          const c = n.dataset.products;
          this.dataset.productCount = c || "0", a.dataset.products = this.dataset.productCount;
        }
        this.dataset.loading = "false";
      }
    }).catch((i) => {
      console.error("Error fetching search results:", i), this.dataset.loading = "false";
    });
  }
  updateState() {
    const t = this.querySelector(
      '[data-count="products"]'
    );
    if (t.innerHTML = this.dataset.productCount !== "0" ? "(" + this.dataset.productCount + ")" : "", this.dataset.productCount === "" || this.dataset.contentCount === "") {
      this.dataset.results = "ready";
      return;
    }
    this.dataset.productCount === "0" && this.dataset.contentCount === "0" ? this.dataset.results = this.input && this.input.value.length > 2 ? "none" : "ready" : this.dataset.results = "some";
  }
};
f.observedAttributes = ["data-product-count", "data-content-count"];
let d = f;
window.customElements.get("search-form") || window.customElements.define("search-form", d);
class T extends HTMLElement {
  constructor() {
    super(), this.tabs = [], this.firstTab = null, this.lastTab = null, this.tabs = Array.from(this.querySelectorAll("[role=tab]")), this.tabpanels = [], this.tabs.forEach((t) => {
      if (!t.hasAttribute("aria-controls"))
        return;
      const e = document.getElementById(
        t.getAttribute("aria-controls")
      );
      t.tabIndex = -1, t.setAttribute("aria-selected", "false"), this.tabpanels.push(e), t.addEventListener("keydown", this.onKeydown.bind(this)), t.addEventListener("click", this.onClick.bind(this)), this.firstTab || (this.firstTab = t), this.lastTab = t;
    }), this.firstTab && this.setSelectedTab(this.firstTab, !1);
  }
  setSelectedTab(t, e = !0) {
    typeof e != "boolean" && (e = !0), this.tabs.forEach((s, i) => {
      t === s ? (s.setAttribute("aria-selected", "true"), s.removeAttribute("tabindex"), this.tabpanels[i].classList.remove("hidden"), e && s.focus()) : (s.setAttribute("aria-selected", "false"), s.tabIndex = -1, this.tabpanels[i].classList.add("hidden"));
    });
  }
  setSelectedToPreviousTab(t) {
    let e;
    t === this.firstTab ? this.setSelectedTab(this.lastTab) : (e = this.tabs.indexOf(t), this.setSelectedTab(this.tabs[e - 1]));
  }
  setSelectedToNextTab(t) {
    let e;
    t === this.lastTab ? this.setSelectedTab(this.firstTab) : (e = this.tabs.indexOf(t), this.setSelectedTab(this.tabs[e + 1]));
  }
  /* EVENT HANDLERS */
  onKeydown(t) {
    const e = t.currentTarget;
    let s = !1;
    switch (t.key) {
      case "ArrowLeft":
        this.setSelectedToPreviousTab(e), s = !0;
        break;
      case "ArrowRight":
        this.setSelectedToNextTab(e), s = !0;
        break;
      case "Home":
        this.setSelectedTab(this.firstTab), s = !0;
        break;
      case "End":
        this.setSelectedTab(this.lastTab), s = !0;
        break;
    }
    s && (t.stopPropagation(), t.preventDefault());
  }
  onClick(t) {
    this.setSelectedTab(t.currentTarget);
  }
}
window.customElements.get("tab-list") || window.customElements.define("tab-list", T);
export {
  d as SearchForm,
  m as renderIcon,
  S as renderSuggestion
};
